:root {
    --tt-primary-color: #2181f7;
}
.dialog {
    border: 0;
    padding: 0;
    overflow: hidden;
    max-width: 450px;
    width: 100%;
    margin: revert;
}

.dialog.fullscreen {
    width: 100%;
    height: 100%;
    max-width: revert;
}

.dialogContainer.fullscreen {
    width: 100%;
    height: 100%;
    min-width: 100%;
    padding: revert;
}

.dialogContainer {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    gap: 2px;
    padding: 5px;
    padding-bottom: 15px;
    min-width: 360px;
    height: 600px;
}

.dialog::backdrop {
    background: rgba(0, 0, 0, 0.7);
}

@media (max-width: 768px) {
    .dialog[open] {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        max-height: 100%;
    }
    .dialogContainer {
        flex: 1;
    }
    body:has(> .dialog[open]) {
        overflow: hidden;
    }
}

.header {
    display: flex;
    margin: 0 10px;
    flex-basis: 45px;
    align-items: center;
}

.poweredBy {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 16px;
    align-items: center;
}

.closeIcon {
    cursor: pointer;
}

.buttonsContainer {
    position: fixed;
    z-index: 1000;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    bottom: 20px;
    right: 20px;
}

@media (max-width: 768px) {
    .buttonsContainer {
        justify-content: center;
        width: 100%;
        right: 0;
    }
}

.button {
    font-size: large;
    font-weight: bold;
    border-radius: 50px;
    border: 0;
    background-color: var(--tt-primary-color);
    color: white;
    width: 165px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    height: 50px;
}

.spinnerContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.spinner {
    width: 48px;
    height: 48px;
    border: 5px solid var(--tt-primary-color);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.iframeContainer {
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
}

.hideIframe {
    display: none;
}

.iframe {
    width: 100%;
    border-width: 0;
}
